import React from "react";
import { GridColumn, GridRow, LabeledText, Stack } from "sprint-common-web";

import { ensureFullTvSeriesContentDetails } from "../../../../../../../common/types/ContentDetails";
import { ContentSubtype } from "../../../../../../../common/types/ContentSubtype";
import { CloudAssetDetails } from "../../../../CloudAssetDetails";
import { CloudTvSeriesVersionInfo } from "./CloudTvSeriesVersionInfo";

type OnPremTvSeriesContentSectionProps = {
    assetDetails: CloudAssetDetails;
};

export const CloudTvSeriesContentSection: React.FunctionComponent<OnPremTvSeriesContentSectionProps> = ({
    assetDetails
}) => {
    ensureFullTvSeriesContentDetails(assetDetails.content);

    return (
        <Stack>
            <GridRow>
                <GridColumn sm={6}>
                    <LabeledText
                        label="Title"
                        value={assetDetails.content.tvSeries.name}
                        testId="tvSeries-name-field"
                        textTooltip
                    />
                    <LabeledText
                        label="Content type"
                        value={ContentSubtype[assetDetails.content.subtype]}
                        testId="tvSeries-content-type-field"
                    />
                    <LabeledText
                        label="Season"
                        value={assetDetails.content.season.name}
                        testId="tvSeries-season-field"
                        textTooltip
                    />
                    <LabeledText
                        label="Episode"
                        value={assetDetails.content.episode.name}
                        testId="tvSeries-episode-field"
                        textTooltip
                    />
                </GridColumn>
                <GridColumn sm={6}>
                    <CloudTvSeriesVersionInfo
                        tvSeriesId={assetDetails.content.tvSeries.id}
                        versionIds={assetDetails.content.versionSummary.ids}
                        episodeId={assetDetails.content.episode.id}
                        seasonId={assetDetails.content.season.id}
                    />
                </GridColumn>
            </GridRow>
        </Stack>
    );
};
